import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Button, Card, CardBody, Col, Container, Form, FormFeedback, FormGroup, Input, InputGroup, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap'
import breadcrumbs from "common/Breadcrumbs"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { useLocation, useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import CountCreate from './CountCreate'
import MakingCreate from './MakingCreate'
import RentCreate from './RentCreate'

const RentMakingCreate = () => {
    let { pathname } = useLocation()
    let { state } = useLocation()
    const [customActiveTab, setcustomActiveTab] = useState(state?.tab || "1")
    const toggleCustom = tab => {
        if (customActiveTab !== tab && !state?.isEdit) {
            setcustomActiveTab(tab)
        }
    };

    return (
        <>
            <React.Fragment>
                <div className="page-content">
                    <Container fluid={true}>
                        <Breadcrumbs
                            parent={breadcrumbs[pathname].parent}
                            breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                            parentLink={breadcrumbs[pathname].parentLink}
                        />

                        <Card>
                            <CardBody>
                                <Row>
                                    <Col md={12}>
                                        <Nav
                                            tabs
                                            className="nav-tabs-custom nav-justified"
                                            style={{ padding: "2px 10px" }}
                                        >
                                            <NavItem
                                                style={{ marginRight: "5px", backgroundColor: customActiveTab !== "1" && state?.isEdit ? "#343a4030" : "", cursor: customActiveTab !== "1" && state?.isEdit ? "not-allowed" : "pointer" }}
                                                onClick={() => {
                                                    toggleCustom("1")
                                                }}
                                            >
                                                <NavLink
                                                    style={{ cursor: "pointer" }}
                                                    className={classNames({
                                                        "active nav-link": customActiveTab === "1",
                                                    })}
                                                >
                                                    <span className="d-block d-sm-none">
                                                        <i className="fas fa-calendar-check"></i>
                                                    </span>
                                                    <span className="d-none d-sm-block">
                                                        Rent
                                                    </span>
                                                </NavLink>
                                            </NavItem>
                                            <NavItem
                                                onClick={() => {
                                                    toggleCustom("2")
                                                }}
                                            >
                                                <NavLink
                                                    style={{ cursor: "pointer", backgroundColor: customActiveTab !== "2" && state?.isEdit ? "#343a4030" : "", cursor: customActiveTab !== "2" && state?.isEdit ? "not-allowed" : "pointer" }}
                                                    className={classNames({
                                                        "active nav-link": customActiveTab === "2",
                                                    })}
                                                >
                                                    <span className="d-block d-sm-none">
                                                        <i className="fas fa-shopping-cart"></i>
                                                    </span>
                                                    <span className="d-none d-sm-block">Making</span>
                                                </NavLink>
                                            </NavItem>
                                            <NavItem
                                                onClick={() => {
                                                    toggleCustom("3")
                                                }}
                                            >
                                                <NavLink
                                                    style={{ cursor: "pointer", backgroundColor: customActiveTab !== "3" && state?.isEdit ? "#343a4030" : "", cursor: customActiveTab !== "3" && state?.isEdit ? "not-allowed" : "pointer" }}
                                                    className={classNames({
                                                        "active nav-link": customActiveTab === "3",
                                                    })}
                                                >
                                                    <span className="d-block d-sm-none">
                                                        <i className="fas fa-shopping-cart"></i>
                                                    </span>
                                                    <span className="d-none d-sm-block">Count</span>
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                    </Col>
                                </Row>
                                <TabContent activeTab={customActiveTab} className="p-3 text-muted">
                                    <TabPane tabId="1" >
                                        {customActiveTab == "1" &&
                                            <RentCreate
                                                unbillId={state?.data?.Id}
                                            />
                                        }
                                    </TabPane>
                                    <TabPane tabId="2">
                                        {customActiveTab == "2" &&
                                            <MakingCreate
                                                data={state?.data}
                                                isEdit={state?.data ? true : false}
                                            />
                                        }
                                    </TabPane>
                                    <TabPane tabId="3">
                                        {customActiveTab == "3" &&
                                            <CountCreate
                                                data={state?.data}
                                                isEdit={state?.data ? true : false}
                                            />
                                        }
                                    </TabPane>
                                </TabContent >
                            </CardBody>
                        </Card >

                    </Container >
                </div >
            </React.Fragment >
        </>
    )
}

export default RentMakingCreate